import React, { useState, useRef } from 'react'
import { ContentContainerWrapper } from 'context/content-container'
import ContentContainerSeq from 'component/content/playlist/player/content-container-seq'
import { getTodayDate } from 'util/global'

const SectionSequential = ({ item, index, currentContentId }) => {
  /* ======================================= Local States ======================================= */
  const [isHovered, setIsHovered] = useState(false)

  /* ========================================= Constants ======================================== */
  const todayDate = getTodayDate(true)

  /* =========================================== Refs =========================================== */
  const refSection = useRef()

  /* ========================================== Output ========================================== */
  return (
    <div className="mb-0">
      <div
        id={item.id}
        style={{
          backgroundColor: isHovered ? '#f6f6f6' : '#f8f9fa',
        }}
      >
        <h5 className="row m-0">
          <a
            ref={refSection}
            type="button"
            className="col row collapsed text-dark ml-0 p-3 border-bottom"
            data-toggle="collapse"
            data-target={'#content' + index}
            aria-expanded="false"
            aria-controls={'content' + index}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div className="col-2 col-lg-1">
              <i className="fas fa-chevron-down" />
            </div>
            <div className="col-10 col-lg-9">
              <span className="f-16 f-w-500">
                {item.urutan}
                {'. '}
                {item.title}
              </span>
            </div>
          </a>
        </h5>
      </div>
      <div
        id={'content' + index}
        className="collapse"
        aria-labelledby={item.id}
        data-parent="#konten-accordion"
      >
        <ul className="list-unstyled mb-0">
          {item.contents.length ? (
            item.contents.map((content) => (
              <ContentContainerWrapper
                key={content.id}
                content={content}
                classId={item.class_id}
                refSection={refSection}
                currentContentId={currentContentId}
              >
                <ContentContainerSeq todayDate={todayDate} />
              </ContentContainerWrapper>
            ))
          ) : (
            <p className="text-muted p-3 mb-0">Belum ada konten.</p>
          )}
        </ul>
      </div>
    </div>
  )
}

export default SectionSequential
